interface PatientSummaryCardProps {
    name: string;
    practice: string;
}

export function PatientSummaryCard({ name, practice }: PatientSummaryCardProps) {
    return (
        <div className="rounded-lg border border-gray-200 bg-gray-50 px-3.5 py-3">
            <div className="flex items-baseline gap-2">
                <span className="text-[10px] font-semibold text-gray-500 uppercase tracking-wider">
                    Patient
                </span>
                <span className="text-sm font-bold text-gray-800 truncate">{name}</span>
            </div>
            <div className="mt-1 flex items-baseline gap-2">
                <span className="text-[10px] font-semibold text-gray-500 uppercase tracking-wider">
                    Practice
                </span>
                <span className="text-xs text-gray-600 truncate">{practice}</span>
            </div>
        </div>
    );
}
